import { PropsWithChildren, ReactNode } from 'react'
import { useAuthLogin } from 'hooks/auth/useAuthLogin'
import { useAuthWallets } from 'hooks/auth/useAuthWallets'
import { Flex } from 'components/primitives'
interface PrivyLoginWrapperProps {
  trigger: ReactNode
}

export const PrivyLoginWrapper = ({
  children,
  trigger,
}: PropsWithChildren<PrivyLoginWrapperProps>) => {
  const { login } = useAuthLogin()
  const { connectedOwnershipWallet } = useAuthWallets()

  if (!connectedOwnershipWallet) {
    return <Flex onClick={() => login()}>{trigger}</Flex>
  }

  return children
}
